/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import { supportSentNotificationTimeout } from 'src/shared/app/support/settings/supportSettings';
import Notification from 'src/shared/app/notification/component/Notification';
import messages from 'src/shared/app/notification/l10n/notificationL10n';

type Props = {
  supportEmail: string,
  handleDismiss: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const MarketFavoriteNotificationDumb = (props: Props): React.Node => {
  const { supportEmail, handleDismiss, intl } = props;

  return (
    <Notification
      timeout={supportSentNotificationTimeout}
      handleDismiss={handleDismiss}
    >
      {intl.formatMessage(messages.supportSentNotification, { supportEmail })}
    </Notification>
  );
};

export default compose(injectIntl)(MarketFavoriteNotificationDumb);
